var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#646A82",
    d: "M10,16.7c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6V6.5l-4.1,4.1c-0.2,0.2-0.4,0.2-0.6,0.2 c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.6c0-0.2,0.1-0.4,0.2-0.6l5.5-5.5c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2-0.1,0.3-0.1 c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2l5.5,5.5c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2 c-0.2,0-0.4-0.1-0.6-0.2l-4.1-4.1v9.3c0,0.2-0.1,0.4-0.2,0.6C10.4,16.6,10.2,16.7,10,16.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpward);
export default __webpack_public_path__ + "static/media/ArrowUpward.3fa4e29d5929bafbd32eae0e3106e39b.svg";
export { ForwardRef as ReactComponent };